var map = {
	"./auth/store.js": "M1fo",
	"./my-account/content/chats/store.js": "pzZo",
	"./my-account/content/chats/view/store.js": "fVUt",
	"./my-account/content/notifications/store.js": "HciG",
	"./my-account/store.js": "AprA"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "KhpS";


//////////////////
// WEBPACK FOOTER
// ./src/views store.js
// module id = KhpS
// module chunks = 13